/* Strain Jams page player. Enhances the server-rendered song list in
   sections/lab-strain-jams.liquid; read that file's header first.

   - ONE <audio> element for the page, preload none: no audio bytes until play.
   - Favorites, playlists and recently played live in localStorage. Nothing
     here talks to a server except the tracker (le-jams-track.js).
   - Phone: the Now Playing sheet is a modal, so it goes through LESheetLock
     (site rule). Its strip shows recently played <- now -> up next; leaving
     the playing song flies its cover into the mini player at the bottom.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-sj]');
  if (!root || !root.querySelector('.sj-row')) return;

  var T = window.LEJamsTrack || { track: function () {}, listenStart: function () {}, listenTick: function () {}, listenGap: function () {}, listenEnd: function () {} };
  var mq = window.matchMedia('(max-width: 767px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  /* Mirrors snippets/lab-strain-jams-icon.liquid */
  var ICONS = {
    play: '<path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.4-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z"/>',
    pause: '<rect x="6" y="5" width="4.2" height="14" rx="1.2"/><rect x="13.8" y="5" width="4.2" height="14" rx="1.2"/>',
    heart: '<path d="M12 20.3l-1.3-1.2C6 14.9 3 12.2 3 8.8 3 6.2 5 4.2 7.6 4.2c1.5 0 2.9.7 3.8 1.8h1.2c.9-1.1 2.3-1.8 3.8-1.8C19 4.2 21 6.2 21 8.8c0 3.4-3 6.1-7.7 10.3z"/>',
    'heart-o': '<path d="M16.4 4.2C19 4.2 21 6.2 21 8.8c0 3.4-3 6.1-7.7 10.3L12 20.3l-1.3-1.2C6 14.9 3 12.2 3 8.8 3 6.2 5 4.2 7.6 4.2c1.7 0 3.3.8 4.4 2.1 1.1-1.3 2.7-2.1 4.4-2.1zm0 2c-1.3 0-2.6.7-3.3 1.8L12 9.6 10.9 8c-.7-1.1-2-1.8-3.3-1.8C6.1 6.2 5 7.3 5 8.8c0 2.4 2.4 4.7 7 8.8 4.6-4.1 7-6.4 7-8.8 0-1.5-1.1-2.6-2.6-2.6z"/>',
    addlist: '<path d="M3 6h12v2H3zm0 5h12v2H3zm0 5h8v2H3zm14-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"/>',
    x: '<path d="M6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4z"/>',
    plus: '<path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6z"/>',
    left: '<path d="M15.7 5.3L9 12l6.7 6.7-1.4 1.4L6.2 12l8.1-8.1z"/>',
    bag: '<path d="M8 7V6a4 4 0 0 1 8 0v1h3.2l.8 14H4l.8-14zm2 0h4V6a2 2 0 0 0-4 0zm-3.3 2l-.55 10h11.7l-.55-10z"/>'
  };
  function icon(n) { return '<svg class="sj-i sj-i--' + n + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICONS[n] + '</svg>'; }

  var GCOL = { 'Hip-Hop': '#DAA423', 'Rap & Trap': '#a3b23a', 'Rock & Metal': '#e2553f', 'Alternative': '#9aa7b8', 'Punk': '#d04870', 'Folk & Country': '#d89a5b', 'Pop': '#ef6fb0', 'Electronic': '#8e6cf0', 'R&B & Soul': '#f08a24', 'Blues & Jazz': '#5b8def', 'Reggae & Ska': '#60B050', 'Latin & Reggaeton': '#f2c94c', 'World': '#36B5C4' };
  function gcol(g) {
    if (!g) return '#36B5C4';
    if (GCOL[g]) return GCOL[g];
    var h = 0; for (var i = 0; i < g.length; i++) h = (h * 31 + g.charCodeAt(i)) % 360;
    return 'hsl(' + h + ' 65% 58%)';
  }

  /* custom.audio_color = "art|deep|soft" RGB triplets, pre-computed from the cover so
     the flood switches with the song instantly (no image download, no canvas). */
  function parseColor(v) {
    var parts = String(v || '').split('|').map(function (c) { return c.trim().split(/\s+/).map(Number); });
    if (parts.length !== 3 || parts.some(function (c) { return c.length !== 3 || c.some(isNaN); })) return null;
    return { art: parts[0], deep: parts[1], soft: parts[2] };
  }
  /* ---------- songs, straight from the server-rendered rows ---------- */
  var SONGS = $$('.sj-row').map(function (li, i) {
    return { i: i, el: li, h: li.dataset.h, rgb: parseColor(li.dataset.color), t: li.dataset.title, s: li.dataset.strain, g: li.dataset.genre || '', d: +li.dataset.dur || 0, src: li.dataset.src, a: li.dataset.thumb, m: li.dataset.md || li.dataset.thumb, A: li.dataset.art || li.dataset.thumb, f: li.dataset.full || li.dataset.art, url: li.dataset.url };
  });
  var byH = {};
  SONGS.forEach(function (s) { byH[s.h] = s; });
  /* A size that does not exist yet (a brand-new song) falls back to the original file. */
  var FULL = {};
  SONGS.forEach(function (s) { [s.a, s.m, s.A].forEach(function (u) { if (u && s.f && u !== s.f) FULL[u] = s.f; }); });
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'IMG' || t.dataset.fb) return;
    var full = FULL[t.getAttribute('src')];
    if (full) { t.dataset.fb = '1'; t.src = full; }
  }, true);
  var counts = {};
  SONGS.forEach(function (s) { if (s.g) counts[s.g] = (counts[s.g] || 0) + 1; });
  $$('.sj-pill').forEach(function (p) {
    var g = p.dataset.g;
    var dot = p.querySelector('.sj-dot');
    if (dot) dot.style.setProperty('--g', gcol(g));
    p.insertAdjacentHTML('beforeend', ' <small>' + (g === 'All' ? SONGS.length : (counts[g] || 0)) + '</small>');
  });

  /* ---------- library ---------- */
  /* Favorites + playlists live on the CUSTOMER ACCOUNT (customer metafield
     custom.jams_library). Liquid prints the saved copy into the page, and
     changes go back through the app proxy /apps/jams/library, which knows who
     is signed in (docs/strain-jams/ACCOUNT-SYNC-SPEC.md). Guests must sign in. */
  var HIST_KEY = 'le-jams-hist-v1';
  var CFG = window.LE_JAMS || {};
  var ACCOUNT = !!CFG.cust;
  var LIB = null;
  try { LIB = JSON.parse((document.querySelector('[data-sj-lib]') || {}).textContent || 'null'); } catch (e) {}
  if (!LIB || !Array.isArray(LIB.pls)) LIB = { v: 1, favs: [], pls: [] };
  var FAV = {};
  (LIB.favs || []).forEach(function (h) { if (byH[h]) FAV[h] = 1; });
  function favCount() { return Object.keys(FAV).length; }
  var saveT = 0, saveFailed = false;
  function saveLib() {
    if (!ACCOUNT) return;
    LIB.favs = Object.keys(FAV);
    LIB.v = 1;
    LIB.updated = Date.now();
    clearTimeout(saveT);
    saveT = setTimeout(pushLib, 600);
  }
  function pushLib() {
    fetch(CFG.syncUrl || '/apps/Jams/library', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify(LIB)
    }).then(function (r) {
      if (!r.ok) throw new Error('save ' + r.status);
      if (saveFailed) { saveFailed = false; toast('Saved to your account'); }
    }).catch(function () {
      if (!saveFailed) toast('Could not save to your account. We will retry.');
      saveFailed = true;
      clearTimeout(saveT);
      saveT = setTimeout(pushLib, 15000);
    });
  }
  /* guest taps a heart or + : explain, send them to sign in, finish the action on return */
  var PENDING_KEY = 'le-jams-pending';
  function needAccount(action, h) {
    if (ACCOUNT) return false;
    signInPrompt(action, h);
    return true;
  }
  function plById(id) { return LIB.pls.filter(function (p) { return p.id === id; })[0]; }
  function pick(hs) { return (hs || []).map(function (h) { return byH[h]; }).filter(Boolean); }

  /* ---------- state ---------- */
  var params = new URLSearchParams(location.search);
  var deep = byH[params.get('song')] || null;
  var hist = pick(store(HIST_KEY) || []);
  var S = {
    q: '', g: 'All', view: 'all', queue: SONGS.slice(),
    cur: deep || hist[hist.length - 1] || SONGS[0],
    playing: false, shuffle: false, repeat: false,
    history: hist.filter(function (s) { return s !== (deep || hist[hist.length - 1] || SONGS[0]); }).slice(-10),
    pendingTrigger: deep ? 'deeplink' : 'click', pendingList: 'all', pendingPos: 0
  };
  function saveHist() { store(HIST_KEY, S.history.concat([S.cur]).slice(-11).map(function (s) { return s.h; })); }

  function filtered() {
    var q = S.q.trim().toLowerCase();
    return SONGS.filter(function (s) {
      return (S.g === 'All' || s.g === S.g) && (!q || (s.t + ' ' + s.s + ' ' + s.g).toLowerCase().indexOf(q) !== -1);
    });
  }
  function upNext(n) {
    var q = S.queue.length ? S.queue : SONGS, i = q.indexOf(S.cur), out = [];
    for (var k = 1; k <= Math.min(n, q.length - 1); k++) out.push(q[(i + k + q.length) % q.length]);
    return out;
  }

  /* ---------- audio ---------- */
  var audio = new Audio();
  audio.preload = 'none';
  var loadedH = null, userStarted = false;
  function curTime() { return audio.dataset.h === S.cur.h ? audio.currentTime : 0; }
  function curDur() { return (audio.dataset.h === S.cur.h && isFinite(audio.duration) && audio.duration) || S.cur.d || 1; }
  function load(s) { if (loadedH !== s.h) { audio.src = s.src; audio.dataset.h = s.h; loadedH = s.h; } }
  function startCurrent() {
    userStarted = true;
    load(S.cur);
    var p = audio.play();
    if (p && p.catch) p.catch(function (err) { if (err && err.name !== 'AbortError') setPlaying(false); });
  }
  function setPlaying(v) {
    S.playing = v;
    root.classList.toggle('is-playing', v);
    $$('[data-act="play"]').forEach(function (b) { b.setAttribute('aria-label', v ? 'Pause' : 'Play'); });
    if ('mediaSession' in navigator) navigator.mediaSession.playbackState = v ? 'playing' : 'paused';
  }
  var listenOpen = false;
  audio.addEventListener('playing', function () {
    setPlaying(true);
    if (!listenOpen) {
      listenOpen = true;
      T.listenStart(S.cur, { trigger: S.pendingTrigger, list: S.pendingList, pos: S.pendingPos });
    }
  });
  audio.addEventListener('pause', function () { if (!audio.ended) { setPlaying(false); T.listenGap(); } });
  audio.addEventListener('seeking', function () { T.listenGap(); });
  audio.addEventListener('timeupdate', function () { tick(); if (S.playing) T.listenTick(audio.currentTime, curDur()); });
  audio.addEventListener('ended', function () {
    T.listenEnd('complete'); listenOpen = false;
    if (S.repeat) { audio.currentTime = 0; S.pendingTrigger = 'autonext'; startCurrent(); return; }
    step(1, 'autonext');
  });
  audio.addEventListener('error', function () {
    if (!audio.src || audio.dataset.h !== S.cur.h) return;
    S.cur.el.classList.add('is-error');
    setPlaying(false);
    toast('This song is not available right now');
    if (listenOpen) { T.listenEnd('error'); listenOpen = false; }
    if (userStarted) setTimeout(function () { step(1, 'autonext'); }, 1400);
  });

  function setCur(s) {
    if (s === S.cur) return;
    if (listenOpen) { T.listenEnd(S.pendingEnd || 'switch'); listenOpen = false; }
    S.pendingEnd = null;
    S.history = S.history.filter(function (x) { return x !== s && x !== S.cur; });
    S.history.push(S.cur);
    if (S.history.length > 10) S.history.shift();
    S.cur = s;
    saveHist();
  }
  function play(s, opts) {
    opts = opts || {};
    if (opts.queue && opts.queue.indexOf(s) !== -1) S.queue = opts.queue.slice();
    else if (S.queue.indexOf(s) === -1) { var f = filtered(); S.queue = f.indexOf(s) !== -1 ? f : SONGS.slice(); }
    S.pendingTrigger = opts.trigger || 'click';
    S.pendingList = opts.list || listName();
    S.pendingPos = S.queue.indexOf(s);
    if (s !== S.cur) S.pendingEnd = 'switch';
    setCur(s);
    renderTrack();
    startCurrent();
  }
  function step(dir, trigger) {
    var q = S.queue.length ? S.queue : SONGS, i = q.indexOf(S.cur);
    if (i < 0) i = 0;
    if (S.shuffle && dir > 0) { var j = i; while (q.length > 1 && j === i) j = Math.floor(Math.random() * q.length); i = j; }
    else i = (i + dir + q.length) % q.length;
    if (trigger !== 'autonext') {
      T.track('jam_skip', mergeSong(S.cur, { at: Math.round(curTime()), dir: dir > 0 ? 'next' : 'prev' }));
      S.pendingEnd = 'skip';
    }
    var wasPlaying = S.playing || trigger === 'autonext';
    S.pendingTrigger = trigger || 'click';
    S.pendingList = listName();
    S.pendingPos = i;
    setCur(q[i]);
    renderTrack();
    if (wasPlaying) startCurrent();
    else { load(S.cur); }
  }
  function toggle() {
    if (S.playing) { audio.pause(); return; }
    if (audio.dataset.h !== S.cur.h) { S.pendingTrigger = S.pendingTrigger || 'click'; }
    startCurrent();
  }
  function seekTo(frac) {
    frac = Math.max(0, Math.min(1, frac));
    var before = curTime();
    load(S.cur);
    var go = function () { audio.currentTime = frac * curDur(); tick(); };
    if (audio.readyState >= 1) go(); else { audio.addEventListener('loadedmetadata', go, { once: true }); audio.load(); }
    T.track('jam_seek', mergeSong(S.cur, { from: Math.round(before), to: Math.round(frac * curDur()) }));
  }
  function mergeSong(s, extra) { var o = T.songProps ? T.songProps(s) : { song: s.h }; for (var k in extra) o[k] = extra[k]; return o; }
  function listName() {
    if (S.view === 'fav') return 'favorites';
    if (S.view.indexOf('pl:') === 0) return 'playlist';
    if (S.q) return 'search';
    if (S.g !== 'All') return 'genre';
    return 'all';
  }

  if ('mediaSession' in navigator) {
    try {
      navigator.mediaSession.setActionHandler('play', function () { startCurrent(); });
      navigator.mediaSession.setActionHandler('pause', function () { audio.pause(); });
      navigator.mediaSession.setActionHandler('previoustrack', function () { step(-1); });
      navigator.mediaSession.setActionHandler('nexttrack', function () { step(1); });
      navigator.mediaSession.setActionHandler('seekto', function (e) { if (e.seekTime != null) seekTo(e.seekTime / curDur()); });
    } catch (e) {}
  }

  /* ---------- color from the cover (needs CORS on the art; falls back to the genre color) ---------- */
  function hexRgb(c) {
    var el = document.createElement('i'); el.style.color = c; document.body.appendChild(el);
    var m = getComputedStyle(el).color.match(/\d+/g); el.remove();
    return m ? m.slice(0, 3).map(Number) : [16, 128, 144];
  }
  function rgbToHsl(r, g, b) { r /= 255; g /= 255; b /= 255; var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, s = 0, l = (mx + mn) / 2; if (mx !== mn) { var d = mx - mn; s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn); h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h /= 6; } return [h, s, l]; }
  function hslToRgb(h, s, l) { if (!s) { var v = Math.round(l * 255); return [v, v, v]; } var q = l < .5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q; function f(t) { if (t < 0) t += 1; if (t > 1) t -= 1; return t < 1 / 6 ? p + (q - p) * 6 * t : t < 1 / 2 ? q : t < 2 / 3 ? p + (q - p) * (2 / 3 - t) * 6 : p; } return [f(h + 1 / 3), f(h), f(h - 1 / 3)].map(function (v) { return Math.round(v * 255); }); }
  function paletteFrom(rgb) { var hsl = rgbToHsl(rgb[0], rgb[1], rgb[2]); var H = hsl[0], Sa = Math.max(.45, Math.min(.85, hsl[1])); return { art: hslToRgb(H, Sa, .42), deep: hslToRgb(H, Math.min(.6, Sa), .13), soft: hslToRgb(H, Math.min(.8, Sa + .1), .66) }; }
  var corsBlocked = false; /* the art host sends no CORS header yet: stop asking after the first refusal */
  function computeColor(s) {
    if (s.rgb) return Promise.resolve(s.rgb);
    if (corsBlocked) { s.rgb = paletteFrom(hexRgb(gcol(s.g))); return Promise.resolve(s.rgb); }
    return new Promise(function (res) {
      var done = function (rgb) { s.rgb = paletteFrom(rgb); res(s.rgb); };
      if (!s.a) return done(hexRgb(gcol(s.g)));
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = c.height = 28;
          var x = c.getContext('2d'); x.drawImage(im, 0, 0, 28, 28);
          var d = x.getImageData(0, 0, 28, 28).data, bins = [];
          for (var b = 0; b < 12; b++) bins.push({ w: 0, r: 0, g: 0, b: 0 });
          for (var k = 0; k < d.length; k += 4) {
            var hsl = rgbToHsl(d[k], d[k + 1], d[k + 2]);
            if (hsl[1] < .25 || hsl[2] < .15 || hsl[2] > .88) continue;
            var w = hsl[1] * (1 - Math.abs(hsl[2] - .5)), bi = bins[Math.floor(hsl[0] * 12) % 12];
            bi.w += w; bi.r += d[k] * w; bi.g += d[k + 1] * w; bi.b += d[k + 2] * w;
          }
          bins.sort(function (a, z) { return z.w - a.w; });
          var best = bins[0];
          done(best.w > 0 ? [best.r / best.w, best.g / best.w, best.b / best.w] : hexRgb(gcol(s.g)));
        } catch (e) { done(hexRgb(gcol(s.g))); }
      };
      im.onerror = function () { corsBlocked = true; done(hexRgb(gcol(s.g))); };
      im.src = s.a;
    });
  }
  function applyColor(c) {
    root.style.setProperty('--sj-art', c.art.join(' '));
    root.style.setProperty('--sj-deep', c.deep.join(' '));
    root.style.setProperty('--sj-soft', c.soft.join(' '));
  }
  function setColor() {
    var s = S.cur;
    if (s.rgb) { applyColor(s.rgb); return; }   /* saved color: same frame as the cover swap */
    computeColor(s).then(function (c) { if (S.cur === s) applyColor(c); });
  }

  /* ---------- rendering ---------- */
  function waveBars(s, n) { var h = 0, i, out = []; for (i = 0; i < s.h.length; i++) h = (h * 31 + s.h.charCodeAt(i)) >>> 0; for (i = 0; i < n; i++) { h = (h * 1103515245 + 12345) >>> 0; var r = (h >>> 16) / 65535, env = Math.sin(Math.PI * (i + .5) / n) * .55 + .45; out.push(Math.round((18 + r * 82) * env)); } return out; }
  function waveHTML(s) { var b = waveBars(s, 46).map(function (v, i) { return '<i style="height:' + v + '%;--d:' + ((i * 337 + v * 7) % 900) + '"></i>'; }).join(''); return '<div class="sj-wave__l">' + b + '</div><div class="sj-wave__l sj-wave__l--top">' + b + '</div>'; }
  function heartBtn(h) { var on = !!FAV[h]; return '<button class="sj-heart' + (on ? ' is-on' : '') + '" type="button" data-act="fav" data-h="' + h + '" aria-pressed="' + on + '" aria-label="Favorite">' + icon('heart-o') + icon('heart') + '</button>'; }
  function addBtn(h, pl) { return pl ? '<button class="sj-add" type="button" data-act="plrm" data-id="' + pl + '" data-h="' + h + '" aria-label="Remove from playlist">' + icon('x') + '</button>' : '<button class="sj-add" type="button" data-act="addpl" data-h="' + h + '" aria-label="Add to a playlist">' + icon('addlist') + '</button>'; }
  function vrow(s, n, pl) {
    return '<div class="sj-vrow' + (s === S.cur ? ' is-cur' : '') + '" role="button" tabindex="0" data-h="' + s.h + '"><span class="sj-n"><span class="sj-num">' + n + '</span><span class="sj-eq" aria-hidden="true"><i></i><i></i><i></i></span></span>' +
      (s.a ? '<img class="sj-thumb" src="' + esc(s.a) + '" alt="" loading="lazy">' : '<span class="sj-thumb"></span>') +
      '<span class="sj-t"><b class="sj-title">' + esc(s.t) + '</b><span class="sj-sub">' + esc(s.s) + (s.g ? ' · ' + esc(s.g) : '') + '</span></span>' +
      '<a class="sj-rowshop" href="' + esc(s.url) + '" data-act="rowshop" data-h="' + s.h + '" target="_blank" rel="noopener" aria-label="Shop ' + esc(s.s) + ' Terpenes">' + icon('bag') + 'Shop</a><span class="sj-g">' + esc(s.g) + '</span><span class="sj-d">' + fmt(s.d) + '</span>' + heartBtn(s.h) + addBtn(s.h, pl) + '</div>';
  }
  function mosaic(hs) {
    var imgs = pick(hs).filter(function (s) { return s.a; }).slice(0, 4);
    if (!imgs.length) return '<span class="sj-mos is-one"></span>';
    if (imgs.length < 4) return '<span class="sj-mos is-one"><img src="' + esc(imgs[0].a) + '" alt=""></span>';
    return '<span class="sj-mos">' + imgs.map(function (s) { return '<img src="' + esc(s.a) + '" alt="">'; }).join('') + '</span>';
  }

  var list = $('[data-sj-list]'), view = $('[data-sj-view]'), empty = $('[data-sj-empty]'), stage = $('[data-sj-stage]');
  function renderViews() {
    var f = filtered(), v = S.view;
    stage.dataset.view = v;
    $$('[data-act="view"]').forEach(function (b) { var on = b.dataset.v === v || (b.dataset.v === 'pl' && v.indexOf('pl:') === 0); b.setAttribute('aria-selected', String(on)); });
    $$('[data-act="genre"]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.g === S.g); });
    bind('countn', f.length);
    bind('favn', favCount());
    if (v === 'all') {
      list.hidden = false; view.hidden = true;
      var keep = {}; f.forEach(function (s) { keep[s.h] = 1; });
      SONGS.forEach(function (s) { s.el.hidden = !keep[s.h]; });
      empty.hidden = f.length > 0;
      view._list = null;
      list._list = f;
      return;
    }
    list.hidden = true; view.hidden = false; empty.hidden = true;
    var html = '', rows = null, pl = null;
    if (v === 'up') rows = [S.cur].concat(upNext(40));
    else if (!ACCOUNT && (v === 'fav' || v === 'pl' || v.indexOf('pl:') === 0)) {
      html = '<div class="sj-signin-card"><span class="sj-signin-card__i">' + icon('heart') + '</span><b>Save your favorite jams</b><p>Sign in to your Lab Effects account to keep favorites and playlists. They will be here every time you come back, on any device.</p><a class="sj-signin-btn" href="' + esc(loginUrl()) + '" data-act="signin">Sign in or create account</a></div>';
    } else if (v === 'fav') {
      rows = f.filter(function (s) { return FAV[s.h]; });
      if (!rows.length) html = '<p class="sj-empty">' + (favCount() ? 'No favorites match this search.' : 'Tap the heart on any song to save it here.') + '</p>';
    } else if (v === 'pl') {
      html = '<div class="sj-plgrid"><button type="button" class="sj-plc sj-plc--fav" data-act="view" data-v="fav"><span class="sj-mos">' + icon('heart') + '</span><b>Favorites</b><span>' + favCount() + ' songs</span></button>' +
        LIB.pls.map(function (p) { return '<button type="button" class="sj-plc" data-act="plopen" data-id="' + p.id + '">' + mosaic(p.songs) + '<b>' + esc(p.name) + '</b><span>' + p.songs.length + ' songs</span></button>'; }).join('') +
        '<button type="button" class="sj-plc sj-plc--new" data-act="plcreate"><span class="sj-mos">+</span><b>New playlist</b><span>Name it, then add songs</span></button></div>';
    } else if (v.indexOf('pl:') === 0) {
      pl = plById(v.slice(3));
      if (!pl) { S.view = 'pl'; return renderViews(); }
      rows = pick(pl.songs);
      var total = rows.reduce(function (a, s) { return a + s.d; }, 0);
      html = '<div class="sj-plhead">' + mosaic(pl.songs) + '<div class="sj-plhead__t"><b>' + esc(pl.name) + '</b><span>' + rows.length + ' songs · ' + fmt(total) + '</span></div>' +
        (rows.length ? '<button class="sj-pbtn" type="button" data-act="plplay" data-id="' + pl.id + '" aria-label="Play this playlist">' + icon('play') + '</button>' : '') + '</div>' +
        '<div class="sj-pltools"><button type="button" class="sj-minibtn" data-act="view" data-v="pl">' + icon('left') + 'Playlists</button><button type="button" class="sj-minibtn" data-act="pldel" data-id="' + pl.id + '">Delete playlist</button></div>' +
        (rows.length ? '' : '<p class="sj-empty">Empty for now. Tap + on any song to add it here.</p>');
    }
    view._list = rows;
    view.innerHTML = html + (rows ? rows.map(function (s, k) { return vrow(s, k + 1, pl && pl.id); }).join('') : '');
  }
  function renderMore() {
    var box = $('[data-sj-more]');
    if (!box) return;
    var g = S.g !== 'All' ? S.g : S.cur.g;
    bind('moregenre', g || 'Strain');
    var pool = SONGS.filter(function (x) { return x !== S.cur && (!g || x.g === g); }).slice(0, 5);
    box.innerHTML = pool.length ? pool.map(function (x) { return '<button type="button" data-h="' + x.h + '" data-from="more">' + (x.m ? '<img src="' + esc(x.m) + '" alt="" loading="lazy">' : '') + '<b>' + esc(x.t) + '</b><span>' + esc(x.s) + '</span></button>'; }).join('') : '<span class="sj-sub">No other ' + esc(g) + ' songs yet.</span>';
  }
  function bind(name, val) { $$('[data-sj-bind="' + name + '"]').forEach(function (el) { el.textContent = val; }); }
  function setHi(el, s) {
    if (el.dataset.hi === s.h) return;
    el.dataset.hi = s.h;
    if (el.getAttribute('src') === s.A) return;   /* already rendered by Liquid */
    if (s.a) el.src = s.a;
    if (s.A && s.A !== s.a) { var im = new Image(); im.onload = function () { if (el.dataset.hi === s.h) el.src = s.A; }; im.src = s.A; }
  }
  function syncFavs() {
    $$('[data-act="fav"]').forEach(function (b) {
      var h = b.hasAttribute('data-favcur') ? S.cur.h : b.dataset.h, on = !!FAV[h];
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on));
    });
    bind('favn', favCount());
  }
  function renderTrack() {
    var s = S.cur;
    $$('[data-sj-bind="art"]').forEach(function (el) { if (s.a && el.getAttribute('src') !== s.a) el.src = s.a; });
    $$('[data-sj-bind="arthi"]').forEach(function (el) { setHi(el, s); });
    $$('[data-sj-bind="bgart"]').forEach(function (el) { el.style.backgroundImage = s.a ? 'url("' + s.a + '")' : 'none'; });
    bind('title', s.t);
    bind('strain', s.s);
    bind('dur', fmt(s.d));
    $$('[data-sj-bind="bigtitle"]').forEach(function (el) { el.textContent = s.t; el.className = 'sj-poster__title' + (s.t.length > 26 ? ' is-l3' : s.t.length > 14 ? ' is-l2' : ''); });
    $$('[data-sj-bind="genre"]').forEach(function (el) { el.innerHTML = s.g ? '<i style="background:' + gcol(s.g) + '"></i>' + esc(s.g) : ''; });
    $$('[data-sj-bind="shop"]').forEach(function (el) {
      el.href = s.url;
      /* desktop opens the product in a new tab so the music keeps playing */
      if (mq.matches) { el.removeAttribute('target'); el.removeAttribute('rel'); } else { el.target = '_blank'; el.rel = 'noopener'; }
    });
    $$('[data-sj-bind="wave"]').forEach(function (el) { el.innerHTML = waveHTML(s); });
    SONGS.forEach(function (x) { x.el.classList.toggle('is-cur', x === s); });
    $$('.sj-vrow').forEach(function (el) { el.classList.toggle('is-cur', el.dataset.h === s.h); });
    var nx = $('[data-sj-upnext]');
    if (nx) nx.innerHTML = upNext(3).map(function (x, k) { return vrow(x, k + 1); }).join('');
    if (S.view === 'up') renderViews();
    if ('mediaSession' in navigator && window.MediaMetadata) {
      try { navigator.mediaSession.metadata = new MediaMetadata({ title: s.t, artist: 'Lab Effects', album: 'Strain Jams', artwork: s.A ? [{ src: s.A, sizes: '960x960' }] : [] }); } catch (e) {}
    }
    setColor(); renderMore(); syncFavs(); renderStrip(); tick();
  }
  function tick() {
    var p = Math.min(1, curTime() / curDur());
    bind('time', fmt(curTime()));
    $$('[data-sj-bind="wave"], [data-sj-bind="prog"]').forEach(function (el) { el.style.setProperty('--p', p.toFixed(4)); });
    $$('.sj-wave').forEach(function (el) { el.setAttribute('aria-valuenow', Math.round(p * 100)); });
  }

  /* ---------- phone: Now Playing sheet + history / up next strip ---------- */
  var strip = $('[data-sj-strip]'), sheetOpen = false, away = false, awayTimer = 0, lockUntil = 0;
  function cardHTML(it) {
    var s = it.s, tag = it.role === 'now' ? 'Now playing' : it.role === 'hist' ? (it.ago === 1 ? 'Just played' : 'Played ' + it.ago + ' songs ago') : (it.pos === 1 ? 'Up next' : 'Coming up · ' + it.pos);
    return '<div class="sj-sc' + (it.role === 'now' ? ' is-now' : '') + '" data-sh="' + s.h + '" data-role="' + it.role + '"><div class="sj-sc__art" style="background-image:url(\'' + esc(s.a) + '\')"><img src="' + esc(s.A) + '" alt="" loading="lazy" decoding="async"><span class="sj-sc__tag">' + tag + '</span>' +
      '<button type="button" class="sj-sc__again" data-act="playh" data-h="' + s.h + '" data-role="' + it.role + '">' + icon('play') + (it.role === 'hist' ? 'Play again' : 'Play now') + '</button></div>' +
      '<div class="sj-sc__meta"><div><b>' + esc(s.t) + '</b><span>' + esc(s.s) + (s.g ? ' · ' + esc(s.g) : '') + '</span></div>' + heartBtn(s.h) + '</div></div>';
  }
  function centered() {
    var mid = strip.scrollLeft + strip.clientWidth / 2, best = null, bd = 1e9;
    $$('.sj-sc', strip).forEach(function (c) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = c; } });
    return best;
  }
  function centerOn(c, smooth) { if (c) strip.scrollTo({ left: c.offsetLeft - (strip.clientWidth - c.offsetWidth) / 2, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' }); }
  function stripScale() { var mid = strip.scrollLeft + strip.clientWidth / 2; $$('.sj-sc', strip).forEach(function (c) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); c.style.setProperty('--s', (1 - Math.min(1, d / 320) * .1).toFixed(3)); }); }
  function renderStrip() {
    if (!strip || !sheetOpen) return;
    var keep = away ? centered() : null;
    var h = S.history.slice(-10), items = h.map(function (s, k) { return { s: s, role: 'hist', ago: h.length - k }; });
    items.push({ s: S.cur, role: 'now' });
    upNext(8).forEach(function (s, k) { items.push({ s: s, role: 'next', pos: k + 1 }); });
    strip.innerHTML = items.map(cardHTML).join('');
    var target = (keep && strip.querySelector('.sj-sc[data-sh="' + keep.dataset.sh + '"]:not(.is-now)')) || strip.querySelector('.sj-sc.is-now');
    lockUntil = Date.now() + 450;
    centerOn(target, false);
    if (!keep || target.classList.contains('is-now')) setAway(false, true);
    stripScale();
  }
  function fly(fromEl, toRect, radius) {
    if (reduceMotion || !fromEl) return;
    var a = fromEl.getBoundingClientRect();
    if (!a.width || !toRect.width) return;
    var c = document.createElement('img');
    c.className = 'sj-flyer';
    c.src = fromEl.currentSrc || fromEl.src;
    c.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;border-radius:' + getComputedStyle(fromEl.parentNode).borderRadius;
    root.appendChild(c);
    var sc = toRect.width / a.width;
    var an = c.animate([{ transform: 'none' }, { transform: 'translate(' + (toRect.left - a.left) + 'px,' + (toRect.top - a.top) + 'px) scale(' + sc + ')', borderRadius: (radius / sc) + 'px' }], { duration: 460, easing: 'cubic-bezier(.45,0,.2,1)' });
    an.onfinish = function () { c.remove(); };
  }
  function setAway(v, silent) {
    if (away === v) return;
    away = v;
    clearTimeout(awayTimer);
    if (v) {
      var nowImg = strip.querySelector('.sj-sc.is-now img'), miniImg = $('.sj-mini--sheet img');
      fly(nowImg, miniImg.getBoundingClientRect(), 9);
      awayTimer = setTimeout(function () { if (away) root.classList.add('is-away'); }, reduceMotion ? 0 : 300);
    } else {
      root.classList.remove('is-away');
    }
    if (!silent && v) {
      var c = centered();
      if (c) T.track('jam_swipe', { dir: c.dataset.role === 'hist' ? 'back' : 'ahead', depth: Math.abs($$('.sj-sc', strip).indexOf(c) - $$('.sj-sc', strip).indexOf(strip.querySelector('.is-now'))) });
    }
  }
  function goHome() {
    var now = strip.querySelector('.sj-sc.is-now'), miniImg = $('.sj-mini--sheet img');
    if (!now) return;
    var sr = strip.getBoundingClientRect(), w = now.offsetWidth;
    var target = { left: sr.left + (sr.width - w) / 2, top: now.querySelector('.sj-sc__art').getBoundingClientRect().top, width: w, height: w };
    lockUntil = Date.now() + 650;
    setAway(false, true);
    fly(miniImg, target, 20);
    centerOn(now, true);
    T.track('jam_return', {});
  }
  if (strip) {
    strip.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        stripScale();
        if (Date.now() < lockUntil) return;
        var now = strip.querySelector('.sj-sc.is-now');
        if (!now) return;
        var d = Math.abs(now.offsetLeft + now.offsetWidth / 2 - (strip.scrollLeft + strip.clientWidth / 2));
        setAway(d > now.offsetWidth * .37);
      });
    }, { passive: true });
  }
  /* The sheet is fixed to the VISIBLE screen. Chrome for iOS puts the layout
     viewport's origin above the visible area (see le-mobile.js, section 0), so
     a plain `inset: 0` sheet hid its top under the toolbar and let the page show
     below it. While the sheet is open the page is scroll-locked and the toolbar
     holds still, so measuring once (and again only when the visual viewport
     itself changes) cannot chase anything. CSS top:0 + 100dvh is the fallback. */
  var nowEl = $('[data-sj-now]'), fitT = 0;
  function fitSheet() {
    var vv = window.visualViewport;
    if (!sheetOpen || !vv || !nowEl) return;
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    var t = Math.round(vv.offsetTop - probe.getBoundingClientRect().top);
    probe.remove();
    if (Math.abs(t) > 150) t = 0;
    nowEl.style.top = t + 'px';
    nowEl.style.height = Math.round(vv.height) + 'px';
  }
  function refit() { clearTimeout(fitT); fitT = setTimeout(fitSheet, 120); }
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', refit); window.visualViewport.addEventListener('scroll', refit); }
  /* le-mobile.js only re-measures the tab-bar correction on scroll/resize, and
     locking + unlocking the page fires neither: nudge it so the tab bar and the
     mini player do not stay where the old toolbar state left them. */
  function nudgeBars() {
    requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
    setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 450);
  }
  function openSheet() {
    if (sheetOpen || !mq.matches) return;
    sheetOpen = true;
    root.classList.add('is-sheet');
    if (window.LESheetLock) window.LESheetLock.lock();
    fitSheet();
    requestAnimationFrame(fitSheet);
    renderStrip();
  }
  function closeSheet() {
    if (!sheetOpen) return;
    sheetOpen = false;
    away = false;
    root.classList.remove('is-sheet', 'is-away');
    if (nowEl) { nowEl.style.top = ''; nowEl.style.height = ''; }
    if (window.LESheetLock) window.LESheetLock.unlock();
    nudgeBars();
  }
  mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches) closeSheet(); });

  /* drag to scroll for mouse users (strip + genre slider) */
  function dragScroll(el, snap) {
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; el.style.scrollSnapType = 'none'; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; el.style.scrollSnapType = '';
      if (snap) centerOn(centered(), true);
      if (moved) el._noclick = Date.now();
    });
    el.addEventListener('click', function (e) { if (el._noclick && Date.now() - el._noclick < 250) { e.stopPropagation(); e.preventDefault(); } }, true);
    if (!snap) el.addEventListener('wheel', function (e) { if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && el.scrollWidth > el.clientWidth) { el.scrollLeft += e.deltaY; e.preventDefault(); } }, { passive: false });
  }
  var track = $('.sj-gslide__track');
  if (track) dragScroll(track, false);
  if (strip) dragScroll(strip, true);

  /* ---------- toast + playlist sheet ---------- */
  var toastEl = $('[data-sj-toast]'), toastT = 0;
  function toast(msg) { toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800); }
  var plSheet = null, plLocked = false;
  function closePl() {
    if (!plSheet) return;
    plSheet.remove(); plSheet = null;
    if (plLocked && window.LESheetLock) { window.LESheetLock.unlock(); nudgeBars(); }
    plLocked = false;
  }
  function openPl(h) {
    closePl();
    var s = h ? byH[h] : null;
    plSheet = document.createElement('div');
    plSheet.className = 'sj-plsheet';
    plSheet.dataset.h = h || '';
    plSheet.setAttribute('role', 'dialog');
    plSheet.setAttribute('aria-modal', 'true');
    plSheet.setAttribute('aria-label', s ? 'Add to a playlist' : 'New playlist');
    var hasLists = !!(s && LIB.pls.length);
    plSheet.innerHTML = '<div class="sj-plsheet__card">' +
      (s ? '<div class="sj-plsheet__song">' + (s.m ? '<img src="' + esc(s.m) + '" alt="">' : '') + '<div><b>' + esc(s.t) + '</b><span>' + esc(s.s) + '</span></div></div>' +
        (hasLists ? '<p class="sj-plsheet__label">Add to a playlist</p><div class="sj-plsheet__list">' + LIB.pls.map(function (p) { var inIt = p.songs.indexOf(h) !== -1; return '<button type="button" data-pl="' + p.id + '">' + mosaic(p.songs) + '<b>' + esc(p.name) + '</b>' + (inIt ? '<span class="is-in">Added</span>' : '<span>' + p.songs.length + ' songs</span>') + '</button>'; }).join('') + '</div>' : '') : '') +
      '<p class="sj-plsheet__label">' + (hasLists ? 'Or start a new playlist' : 'Name your new playlist') + '</p>' +
      '<form class="sj-plsheet__form"><input class="sj-plsheet__input" type="text" maxlength="40" placeholder="e.g. Late Night Jams" aria-label="Playlist name" enterkeyhint="done" autocomplete="off">' +
      '<button class="sj-plsheet__create" type="submit" disabled>' + icon('plus') + (s ? 'Create playlist and add song' : 'Create playlist') + '</button></form>' +
      '<button type="button" class="sj-plsheet__done">' + (hasLists ? 'Done' : 'Cancel') + '</button></div>';
    document.body.appendChild(plSheet);
    if (window.LESheetLock && !(sheetOpen)) { window.LESheetLock.lock(); plLocked = true; }
    plSheet.addEventListener('click', function (e) {
      if (e.target === plSheet || e.target.closest('.sj-plsheet__done')) { closePl(); return; }
      var b = e.target.closest('[data-pl]');
      if (b) {
        var p = plById(b.dataset.pl);
        if (p && p.songs.indexOf(h) === -1) { p.songs.push(h); saveLib(); T.track('jam_playlist', { action: 'add', pl: p.id, pl_size: p.songs.length, song: h }); }
        closePl(); toast('Added to ' + p.name); renderViews();
      }
    });
    var plInput = plSheet.querySelector('.sj-plsheet__input'), plCreate = plSheet.querySelector('.sj-plsheet__create');
    plInput.addEventListener('input', function () { plCreate.disabled = !plInput.value.trim(); });
    plSheet.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = plInput, name = input.value.trim();
      if (!name) { input.focus(); return; }
      var p = { id: 'p' + Date.now().toString(36), name: name, songs: h ? [h] : [] };
      LIB.pls.push(p); saveLib();
      T.track('jam_playlist', { action: 'create', pl: p.id, pl_size: p.songs.length });
      closePl();
      toast(h ? 'Added to ' + name : 'Created ' + name);
      if (!h) S.view = 'pl:' + p.id;
      renderViews();
    });
    if (!hasLists) setTimeout(function () { if (plSheet) plInput.focus({ preventScroll: true }); }, 50);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (plSheet) closePl(); else if (sheetOpen) closeSheet();
  });

  function loginUrl(h) {
    var back = location.pathname + '?song=' + encodeURIComponent(h || S.cur.h);
    return (CFG.login || '/customer_authentication/login?return_to=') + encodeURIComponent(back);
  }
  function rememberPending(action, h) {
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify({ a: action, h: h, t: Date.now() })); } catch (e) {}
  }
  function signInPrompt(action, h) {
    closePl();
    var s = h ? byH[h] : null;
    T.track('jam_signin_prompt', { reason: action, song: h || '' });
    plSheet = document.createElement('div');
    plSheet.className = 'sj-plsheet';
    plSheet.setAttribute('role', 'dialog');
    plSheet.setAttribute('aria-modal', 'true');
    plSheet.setAttribute('aria-label', 'Sign in to save');
    var what = action === 'fav' ? 'save this song to your Favorites' : 'build playlists';
    plSheet.innerHTML = '<div class="sj-plsheet__card">' +
      (s ? '<div class="sj-plsheet__song">' + (s.m ? '<img src="' + esc(s.m) + '" alt="">' : '') + '<div><b>' + esc(s.t) + '</b><span>' + esc(s.s) + '</span></div></div>' : '') +
      '<p class="sj-plsheet__title">Sign in to ' + what + '</p>' +
      '<p class="sj-plsheet__text">Favorites and playlists are saved to your Lab Effects account, so they are waiting for you every time you sign in, on any device. Listening is always free.</p>' +
      '<a class="sj-plsheet__create" href="' + esc(loginUrl(h)) + '" data-signin>Sign in or create account</a>' +
      '<button type="button" class="sj-plsheet__done">Not now</button></div>';
    document.body.appendChild(plSheet);
    if (window.LESheetLock && !sheetOpen) { window.LESheetLock.lock(); plLocked = true; }
    plSheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-signin]')) { rememberPending(action, h); T.track('jam_signin_click', { from: action }); return; }
      if (e.target === plSheet || e.target.closest('.sj-plsheet__done')) closePl();
    });
  }
  /* back from sign-in: finish what the shopper tapped before signing in */
  function resumePending() {
    var p = null;
    try { p = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
    if (!p || !ACCOUNT || Date.now() - p.t > 30 * 60 * 1000) return;
    T.track('jam_signin_return', { reason: p.a || 'card' });
    if (p.a === 'fav' && p.h && byH[p.h] && !FAV[p.h]) {
      FAV[p.h] = 1; saveLib(); syncFavs(); toast('Added to Favorites');
      T.track('jam_favorite', mergeSong(byH[p.h], { on: 1, favs_total: favCount() }));
    } else if (p.a === 'addpl' && p.h && byH[p.h]) openPl(p.h);
    else if (p.a === 'plcreate') openPl(null);
  }

  function share() {
    var s = S.cur, url = location.origin + location.pathname + '?song=' + encodeURIComponent(s.h);
    var data = { title: s.t + ' | Strain Jams by Lab Effects', text: s.t + ', the ' + s.s + ' song by Lab Effects', url: url };
    if (navigator.share) {
      navigator.share(data).then(function () { T.track('jam_share', mergeSong(s, { method: 'native' })); }).catch(function () {});
      return;
    }
    var done = function () { toast('Link copied'); T.track('jam_share', mergeSong(s, { method: 'copy' })); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { prompt('Copy this link', url); });
    else prompt('Copy this link', url);
  }

  /* ---------- events ---------- */
  var searchT = 0;
  root.addEventListener('click', function (e) {
    var act = e.target.closest('[data-act]'), hEl = e.target.closest('[data-h]');
    if (act && root.contains(act)) {
      var a = act.dataset.act;
      if (a === 'play') { e.stopPropagation(); toggle(); return; }
      if (a === 'next') { step(1); return; }
      if (a === 'prev') { if (curTime() > 3) { audio.currentTime = 0; tick(); } else step(-1); return; }
      if (a === 'shuffle' || a === 'repeat') {
        S[a] = !S[a];
        $$('[data-act="' + a + '"]').forEach(function (b) { b.setAttribute('aria-pressed', String(S[a])); });
        return;
      }
      if (a === 'seek') { var r = act.getBoundingClientRect(); seekTo((e.clientX - r.left) / r.width); return; }
      if (a === 'genre') {
        S.g = act.dataset.g;
        if (S.view !== 'all' && S.view !== 'fav') S.view = 'all';
        if (S.g !== 'All') T.track('jam_filter', { genre: S.g });
        renderViews(); renderMore(); return;
      }
      if (a === 'view') { S.view = act.dataset.v; renderViews(); return; }
      if (a === 'searchtoggle') { openSearch(); return; }
      if (a === 'sxclose') { closeSearch(); return; }
      if (a === 'fav') {
        e.stopPropagation();
        var h = act.hasAttribute('data-favcur') ? S.cur.h : act.dataset.h, on = !FAV[h];
        if (needAccount('fav', h)) return;
        if (on) FAV[h] = 1; else delete FAV[h];
        saveLib(); syncFavs();
        act.classList.remove('is-pop'); void act.offsetWidth; if (on) act.classList.add('is-pop');
        toast(on ? 'Added to Favorites' : 'Removed from Favorites');
        T.track('jam_favorite', mergeSong(byH[h], { on: on ? 1 : 0, favs_total: favCount() }));
        if (S.view === 'fav' || S.view === 'pl') renderViews();
        return;
      }
      if (a === 'addpl') { e.stopPropagation(); if (needAccount('addpl', act.dataset.h || S.cur.h)) return; openPl(act.dataset.h || S.cur.h); return; }
      if (a === 'plcreate') { if (needAccount('plcreate', null)) return; openPl(null); return; }
      if (a === 'signin') { rememberPending(null, null); T.track('jam_signin_click', { from: 'card' }); return; }
      if (a === 'plopen') { S.view = 'pl:' + act.dataset.id; renderViews(); return; }
      if (a === 'plplay') { var pl = plById(act.dataset.id), rows = pick(pl && pl.songs); if (rows.length) { T.track('jam_playlist', { action: 'play', pl: pl.id, pl_size: rows.length }); play(rows[0], { queue: rows, trigger: 'playlist', list: 'playlist' }); } return; }
      if (a === 'pldel') {
        if (act.dataset.armed) {
          LIB.pls = LIB.pls.filter(function (p) { return p.id !== act.dataset.id; }); saveLib();
          T.track('jam_playlist', { action: 'delete', pl: act.dataset.id, pl_size: 0 });
          S.view = 'pl'; renderViews(); toast('Playlist deleted');
        } else {
          act.dataset.armed = '1'; act.textContent = 'Tap again to delete'; act.classList.add('is-warn');
          setTimeout(function () { if (act.isConnected) { delete act.dataset.armed; act.textContent = 'Delete playlist'; act.classList.remove('is-warn'); } }, 2500);
        }
        return;
      }
      if (a === 'plrm') {
        e.stopPropagation();
        var p2 = plById(act.dataset.id);
        if (p2) { p2.songs = p2.songs.filter(function (x) { return x !== act.dataset.h; }); saveLib(); T.track('jam_playlist', { action: 'remove', pl: p2.id, pl_size: p2.songs.length, song: act.dataset.h }); }
        renderViews(); return;
      }
      if (a === 'playh') { e.stopPropagation(); play(byH[act.dataset.h], { trigger: act.dataset.role === 'hist' ? 'history' : 'upnext' }); return; }
      if (a === 'sheet-open') { if (!e.target.closest('button')) openSheet(); return; }
      if (a === 'sheet-close') { closeSheet(); return; }
      if (a === 'home') { if (!e.target.closest('button')) goHome(); return; }
      if (a === 'strip') { var c = centered(), t = c && (+act.dataset.d < 0 ? c.previousElementSibling : c.nextElementSibling); if (t) centerOn(t, true); return; }
      if (a === 'share') { share(); return; }
      if (a === 'shop') {
        T.track('jam_shop_click', mergeSong(S.cur, {}));
        return;
      }
      if (a === 'rowshop') {
        e.stopPropagation();
        if (byH[act.dataset.h]) T.track('jam_shop_click', mergeSong(byH[act.dataset.h], { from: 'row' }));
        return;
      }
    }
    if (e.target.closest('a, summary, .sj-lyrics')) return;
    if (hEl && sxList && sxList.contains(hEl)) {
      var hit = byH[hEl.dataset.h];
      if (!hit) return;
      closeSearch();
      if (hit !== S.cur) play(hit, { queue: SONGS.slice(), trigger: 'search' });
      else if (!S.playing) toggle();
      openSheet();
      return;
    }
    if (hEl && root.contains(hEl) && !e.target.closest('.sj-strip')) {
      var s = byH[hEl.dataset.h];
      if (!s) return;
      if (s === S.cur) { toggle(); return; }
      var lc = hEl.closest('[data-sj-list], [data-sj-view]');
      play(s, { queue: lc && lc._list, trigger: hEl.dataset.from === 'more' ? 'click' : (hEl.closest('[data-sj-upnext]') ? 'upnext' : 'click') });
    }
  });
  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.sj-row, .sj-vrow, .sj-mini')) { e.preventDefault(); e.target.click(); }
    if (e.target.matches('.sj-wave') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { e.preventDefault(); seekTo((curTime() + (e.key === 'ArrowRight' ? 10 : -10)) / curDur()); }
  });
  var search = $('[data-sj-search]');
  if (search) search.addEventListener('input', function () {
    S.q = search.value;
    if (S.view !== 'all' && S.view !== 'fav') S.view = 'all';
    renderViews();
    clearTimeout(searchT);
    searchT = setTimeout(function () { var q = S.q.trim().toLowerCase().slice(0, 60); if (q) T.track('jam_search', { q: q, results: filtered().length }); }, 800);
  });

  /* ---------- phone search screen ---------- */
  /* Best match first: title starts with the query, a title word starts with
     it, title contains it, then strain, then genre. Empty query lists all. */
  var sx = $('[data-sj-sx]'), sxQ = $('[data-sj-sxq]'), sxList = $('[data-sj-sxlist]'), sxMeta = $('[data-sj-sxmeta]'), sxOpen = false, sxT = 0;
  function sxRank(s, q) {
    var t = s.t.toLowerCase(), st = s.s.toLowerCase(), g = (s.g || '').toLowerCase();
    if (t.indexOf(q) === 0) return 0;
    if ((' ' + t).indexOf(' ' + q) !== -1) return 1;
    if (t.indexOf(q) !== -1) return 2;
    if (st.indexOf(q) === 0 || (' ' + st).indexOf(' ' + q) !== -1) return 3;
    if (st.indexOf(q) !== -1) return 4;
    if (g.indexOf(q) !== -1) return 5;
    return -1;
  }
  function sxRender() {
    var q = sxQ.value.trim().toLowerCase(), hits;
    if (!q) hits = SONGS.slice();
    else hits = SONGS.map(function (s) { return { s: s, r: sxRank(s, q) }; })
      .filter(function (x) { return x.r >= 0; })
      .sort(function (x, y) { return x.r - y.r || x.s.t.localeCompare(y.s.t); })
      .map(function (x) { return x.s; });
    sxMeta.textContent = !q ? 'All ' + SONGS.length + ' songs' : hits.length ? hits.length + (hits.length === 1 ? ' song' : ' songs') : 'No songs match. Try a song, strain or genre.';
    sxList.innerHTML = hits.map(function (s, i) { return vrow(s, i + 1); }).join('');
    sxList.scrollTop = 0;
    clearTimeout(sxT);
    if (q) sxT = setTimeout(function () { T.track('jam_search', { q: q.slice(0, 60), results: hits.length, ui: 'sheet' }); }, 800);
  }
  function sxFit() {
    var vv = window.visualViewport;
    if (!sxOpen || !vv) return;
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    var t = Math.round(vv.offsetTop - probe.getBoundingClientRect().top);
    probe.remove();
    if (Math.abs(t) > 400) t = 0;
    sx.style.top = t + 'px';
    sx.style.height = Math.round(vv.height) + 'px';
  }
  function openSearch() {
    if (!sx || sxOpen) return;
    sxOpen = true;
    sx.hidden = false;
    if (window.LESheetLock) window.LESheetLock.lock();
    sxRender();
    sxQ.focus({ preventScroll: true });
    sxFit();
    requestAnimationFrame(sxFit);
  }
  function closeSearch() {
    if (!sxOpen) return;
    sxOpen = false;
    sxQ.blur();
    sx.hidden = true;
    sx.style.top = ''; sx.style.height = '';
    if (window.LESheetLock) window.LESheetLock.unlock();
    nudgeBars();
  }
  if (sx) {
    sxQ.addEventListener('input', sxRender);
    sxQ.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); sxQ.blur(); }
      if (e.key === 'Escape') closeSearch();
    });
    /* scrolling the results drops the keyboard so more of them show */
    sxList.addEventListener('touchmove', function () { if (document.activeElement === sxQ) sxQ.blur(); }, { passive: true });
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', sxFit); window.visualViewport.addEventListener('scroll', sxFit); }
    mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches) closeSearch(); });
  }

  /* ---------- boot ---------- */
  list._list = SONGS.slice();
  renderViews();
  renderTrack();
  load(S.cur);
  T.track('jams_view', { songs: SONGS.length, deeplink: deep ? deep.h : '', account: ACCOUNT ? 1 : 0, favs: favCount(), playlists: LIB.pls.length });
  resumePending();
  if (deep) {
    setTimeout(function () { deep.el.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); }, 300);
  }
})();
